// src/App.js
import React, {useState} from 'react';
import { Routes, Route } from 'react-router-dom';
// import { Provider } from 'react-redux';
// import { store } from './app/store';

import AppLayout from './layouts/AppLayout';
// import SchemeCompareLayout from './layouts/SchemeCompareLayout';
import AuthLayoutBasic from './layouts/AuthLayoutBasic';
import AuthLayoutAfterSignUp from './layouts/AuthLayoutAfterSignUp';
import AuthLayoutAfterFpwd from './layouts/AuthLayoutAfterFpwd';
import AppLayoutNoSidebar from './layouts/AppLayoutNoSidebar';
import AppLayoutAlternates from './layouts/AppLayoutAlternates';

import Dashboard from './pages/Dashboard';
import UserFundSchemes from './pages/UserFundSchemes';
import UserFundSchemes2 from './pages/UserFundSchemes2';

import UserFundPlanner from './pages/UserFundPlanner';
import UserSchemesWatchList from './pages/UserSchemesWatchList';
import UserSchemesWatchListSubstitute from './pages/UserSchemesWatchListSubstitutes';

import SchemeCompareList from './features/schemes/SchemeCompareList';
import SchemeAlternates from './features/schemes/SchemeAlternates2';

import Login from './features/auth/Login';
import Register from './features/auth/Register';
// import ProtectedRoute from './routes/ProtectedRoute';
import { ShowIfNotLoggedIn, ShowIfLoggedInAndVerified, ShowIfLoggedInAndNotVerified, ShowIfLoggedInMustChangePwd } from './features/auth/auth_utils';
import Home from './pages/Home';
import ChangePassword from './features/auth/ChangePassword';
import VerifyEmail from './features/auth/VerifyEmail';
import ForgotPassword from './features/auth/ForgotPassword';
import APIkeyMgr from './pages/APIkeyMgr';

import 'bootstrap/dist/css/bootstrap.min.css';
import './styles.css';

function AppMain() {

  const [filters, setFilters] = useState({
    fundHouses: [],
  });
  const [fundFilterChanged, setFundFilterChanged] = useState(false);
  
  const [myFilters, setMyFilters] = useState({
    fundHouses: [],
  });

  const onChange = (type, value) => {
      console.log("Updated value in App.js 1: ", type, value);
      const current = new Set(filters[type]);
      if (current.has(value)) current.delete(value);
      else current.add(value);
      console.log("Updated value in App.js 2: ", current);
      setFilters ({ ...filters, [type]: Array.from(current) });
      setFundFilterChanged(true);
  }

  const onMyChange = (type, value) => {
      console.log("onMyChange - Updated value in App.js 1: ", type, value);
      const current = new Set(myFilters[type]);
      if (current.has(value)) current.delete(value);
      else current.add(value);
      console.log("onMyChange - Updated value in App.js 2: ", current);
      setMyFilters ({ ...myFilters, [type]: Array.from(current) });
  }

  const onNoChange = (type, value) => {
      console.log("onNoChange - Expected update in App.js 3: ", type, value);
      const current = new Set(myFilters[type]);

      console.log("onNoChange - Value can not be Changed in App.js 4: ", current);
  }

  return (
    <>
        <Routes>
          {/* Auth pages – no sidebar */}
          <Route element={
            <ShowIfNotLoggedIn>
                <AuthLayoutBasic />
            </ShowIfNotLoggedIn>
            }>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Register />} />
            <Route path="/forgotPassword" element={<ForgotPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Route>
          <Route element={
                <AuthLayoutBasic />
            }>
            <Route path="/" element={<Home />} />
          </Route>

          <Route element={
                <ShowIfLoggedInMustChangePwd>
                    <AuthLayoutAfterFpwd />
                </ShowIfLoggedInMustChangePwd>
            }>
            <Route 
                path="/change-password" 
                element={<ChangePassword />} 
            />
          </Route>

          <Route
            element={
              <ShowIfLoggedInAndVerified>
                <AppLayoutNoSidebar />
              </ShowIfLoggedInAndVerified>
            }
          >         
            <Route path="/userFundPlanner" element={<UserFundPlanner />} />
            <Route path="/GenAPIkey" element={<APIkeyMgr />} />
            <Route path="/userSchemesWatchListSubstitute" element={
                  <ShowIfLoggedInAndVerified>
                      <UserSchemesWatchListSubstitute filters={myFilters} />
                  </ShowIfLoggedInAndVerified>
                } />
            <Route path="/userFundSchemes2" element={
                  <ShowIfLoggedInAndVerified>
                      <UserFundSchemes2 filters={myFilters} />
                  </ShowIfLoggedInAndVerified>
                } />
          </Route> 
          {/* Default app layout – standard sidebar */}

          <Route
            element={
              <ShowIfLoggedInAndVerified>
                <AppLayout filters={filters} onChange={onChange} />
              </ShowIfLoggedInAndVerified>
            }
          >
            <Route path="/dashboard" element={<Dashboard filters={filters} />} />
          </Route>

          <Route
            element={
              <ShowIfLoggedInAndVerified>
                <AppLayout filters={myFilters} onChange={onMyChange} />
              </ShowIfLoggedInAndVerified>
            }
          >
            <Route path="/userSchemesWatchList" element={<UserSchemesWatchList filters={myFilters} />} />
            <Route path="/userFundSchemes" element={<UserFundSchemes filters={myFilters} />} />
            <Route path="/schemeAlternates" element={
                  <ShowIfLoggedInAndVerified>
                      <SchemeAlternates filters={myFilters} scheme_code={''} />
                  </ShowIfLoggedInAndVerified>
                } />
            <Route path="/compareSchemes" element={<SchemeCompareList filters={myFilters} />} />
          </Route>

        </Routes>
    </>
  );
}

export default AppMain;
